<script>

export let type = null
export let disabled = null
export let name = ""
export let id = ""
export let value = ""
export let checked = false
export let required = null 
export let rows = 3
export let label = ""
export let fixed = false
export let autocomplete = null
export let autofocus = null
export let labelwidth="150px"
export let max = 5
export let valueField = "id"
export let labelField = "name"
export let placeholder = ""
export let items = []
export let style = ""
import TypeAhead from "./typeahead.svelte"

let taValue = ""

const SLOTS = $$props.$$slots // HACK!! until https://github.com/sveltejs/svelte/issues/2106 is resolved

const handleInput = (event) => {
  value = event.target.value;
}
if((""+labelwidth).match(/^[0-9]+$/)) // if it's just a number add px
  labelwidth+="px"

</script>

<div class={"form-row" + (SLOTS && SLOTS.suffix ? " hasSuffix" : "") + (SLOTS && SLOTS.prefix ? " hasPrefix" : "")} style={style} >
  
  {#if type == "checkbox"}
      <input style="margin-left:{parseInt(labelwidth,10)+14}px" type="checkbox" id={id || name} {autofocus} {autocomplete} {placeholder} disabled={disabled || fixed} {required} name={name} bind:checked={checked} on:change on:focus on:blur />
      {#if label}
        <label class="checkboxLabel" for={id || name} >{label}</label>
      {/if}
  {/if}

  {#if type != "checkbox"}
    {#if label}
      <label style="width:{labelwidth};" for={id || name} >{label}</label>
    {/if}
    <slot name="prefix" />
    {#if fixed}
      <div class="form-input-static">{value}</div>
    {:else if type == "textarea"}
        <textarea type="text" id={id || name} class="form-input" {autofocus} {autocomplete} disabled={disabled} {placeholder} {rows} {required} name={name} bind:value={value} on:change on:focus on:blur></textarea>
    {:else if type == "select"}
        <select type="text" id={id || name} class="form-input" {autofocus} {autocomplete} disabled={disabled} {required} name={name} bind:value={value} on:change on:focus on:blur>
          <slot></slot>
        </select>
    {:else if type == "static"}
      <div class="form-input-static">{value}</div>
    {:else if type == "typeahead"}
      <TypeAhead bind:items={items} labelFieldName={labelField} bind:value={value} valueFieldName={valueField} maxItemsToShowInList={max} />
    {:else if type!=null}
      <input type={type} id={id || name} class={["checkbox","radio","range"].includes(type) ? "" : "form-input"} {autofocus} {autocomplete} {placeholder} disabled={disabled} {required} name={name} value={value} on:input="{handleInput}" on:input on:change on:focus on:blur />
    {:else}
      <div class="slotwrap">
        <slot />
      </div>
    {/if}
  {/if}
  <slot name="suffix" />
</div>

<style>
  .form-row{
    display:flex;
    margin:5px;
    box-sizing: border-box;
  }

  .form-row * {
    box-sizing: border-box;
  }

  .form-row label{
    text-align:right;
    margin:7px;
  }
  .form-row :global(.form-input){
    flex:3;
    padding:5px 8px;
    font-size:14px;
    box-sizing: border-box;
  }
  .slotwrap{
    flex:3;
  }

  .form-row .checkboxLabel{
    padding:0;
    margin:3px 0;
    text-align:left;
  }
  .form-row :global([slot="suffix"] .sbtn){
    border-radius:0 var(--s-border-radius,4px) var(--s-border-radius,4px) 0;
    margin:0;
  }
  
  .form-row.hasSuffix :global([slot="suffix"] > :not(button)),.form-row.hasPrefix :global([slot="prefix"] > :not(button)){
    display:block;
    padding: 8px 12px;
    border: 1px solid #ccc;
  }

  .form-row.hasSuffix :global([slot="suffix"] > :not(button)){
    border-radius:0 var(--s-border-radius,4px) var(--s-border-radius,4px) 0;
  }
  .form-row.hasPrefix :global([slot="prefix"] > :not(button)){
    border-radius:var(--s-border-radius,4px) 0 0 var(--s-border-radius,4px);
  }

  .form-row :global([slot="prefix"] .sbtn){
    border-radius:var(--s-border-radius,4px) 0 0 var(--s-border-radius,4px);
    margin:0;
  }

  .form-row :global(input.form-input,select.form-input,textarea.form-input,div.form-input){
    font-weight:normal;
    border-radius:var(--s-border-radius,4px);
    display: block;
    width: 100%;
    font-size: 14px;
    line-height: 1.428571429;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    margin: 0;
    height:34px;
    padding: 4px 8px 5px 8px;
  }

  .form-row :global(.form-input-static){
    display:block;
    padding: 6px 8px 5px 8px;
    line-height: 1.428571429;
    height:34px;
  }

  .form-row :global(textarea.form-input,div.form-input){
    height:auto;
  }

  .form-row.hasSuffix :global(input.form-input){
    border-radius:var(--s-border-radius,4px) 0 0 var(--s-border-radius,4px);
    border-right:0px;
  }

  .form-row.hasPrefix :global(input.form-input){
    border-radius:0 var(--s-border-radius,4px) var(--s-border-radius,4px) 0;
    border-left:0px;
  }

  .form-row :global(input[type=range]){
    flex:3;
    display:block;
  }

  .form-row :global(input[type=color]){
    padding:0;
    height:35px;
    width:40px;
    flex:none;
  }

  .form-row :global(input[type=checkbox],input[type=radio]){
    width:auto;
    border:0;
    margin: 7px 5px;
  }

  .checkboxLabel{
    padding: 0;
    margin: 3px 0;
    text-align: left;
  }

  label {
    padding: 2px 8px 4px 8px;
  }

  /* Mobile, put lable on line above */
  @media only screen and (max-width: 600px) {
    .form-row{
      flex-wrap: wrap;
      justify-content: space-between;
    }
  
    .form-row label{
      text-align:left;
      margin:0;
      width:100%!important
    }
  }
  
</style>